import { useEffect, useState } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import LoginNavbar from '../components/auth/LoginNavbar';

const EmailLink = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [buttonText, setButtonText] = useState<string | null>(null);
  const [token, setToken] = useState<string>('');
  const [type, setType] = useState<string>('');
  const [redirectTo, setRedirectTo] = useState<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    let buttonText = 'Continue to destination';

    setToken(searchParams.get('token') ?? '');

    // Set type based on the current route
    switch (currentPath) {
      case '/login/confirm':
        setType('signup');
        setRedirectTo(`${window.location.origin}/login`);
        buttonText = 'Sign up';
        break;
      case '/login/recover':
        setType('recovery');
        setRedirectTo(`${window.location.origin}/login?action=update_password`);
        buttonText = 'Reset password';
        break;
      case '/login/accept-invitation':
        setType('invite');
        setRedirectTo(`${window.location.origin}/login?action=update_password`);
        buttonText = 'Accept invitation';
        break;
      case '/login/magic-link':
        setType('magiclink');
        setRedirectTo(`${window.location.origin}/login`);
        buttonText = 'Sign in automatically';
        break;
      default:
        console.error('Unknown email verification type');
        setType('unknown');
        setRedirectTo(`${window.location.origin}/login`);
    }

    setButtonText(buttonText);
  }, [searchParams, location.pathname]);

  return (
    <>
      <LoginNavbar />
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#FEF0E6] to-white dark:from-gray-900 dark:to-gray-800 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <img src="/assets/jua-logo.svg" alt="Jua" className="mx-auto h-12 w-auto dark:invert" />
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
              Redirecting you to Jua
            </h2>
          </div>

          <div className="bg-white dark:bg-gray-800 shadow-xl rounded-lg p-6">
            <div className="space-y-4 text-center">
              <p className="text-gray-600 dark:text-gray-300">
                Please click the button below to continue:
              </p>

              {!!buttonText && (
                <form
                  action={`${import.meta.env.VITE_API_BASE_URL}/v1/profile/email-interstitial`}
                  method="post"
                >
                  <input type="hidden" name="token" value={token} />
                  <input type="hidden" name="type" value={type} />
                  <input type="hidden" name="redirect_to" value={redirectTo} />
                  <button
                    type="submit"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#E34290] hover:bg-[#E34290]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
                    data-ph-capture-attribute="btn-email-submit"
                  >
                    {buttonText}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailLink;
